<template>
  <div>
    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="btn">
        <el-button type="primary" size="small" icon="el-icon-download" @click="downloadTemplate">
          下载模板
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="doSave">
          保存
        </el-button>
      </div>
    </div>
    <el-upload
      drag
      :file-list="fileList"
      :http-request="addFile"
      :before-remove="delFile"
      :on-change="handleChange"
      :multiple="false"
      accept=".xls,.xlsx"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">请上传 .xls,.xlsx 标准格式文件</div>
    </el-upload>
  </div>
</template>

<script>
import request from '@/util/request';
import qs from 'qs';
import { getToken } from '@/util/auth';

export default {
  name: 'ImportFile',
  props: {
    /* 数据模块的名称 */
    title: {
      type: String,
      default: '数据导入',
    },
    /* 下载模板的API */
    exportApi: {
      type: String,
      required: true,
    },
    /* 下载模板时携带的接口参数 */
    exportParams: {
      type: Object,
    },
    /* 导入的API */
    importApi: {
      type: String,
      required: true,
    },
    /* 导入时携带的接口参数 */
    importParams: {
      type: Object,
    },
    /* 导入成功的提示语是否使用接口返回的 */
    withApiTips: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    /* 模板下载 */
    downloadTemplate() {
      let params = '';
      if (this.exportParams) {
        params = '&' + qs.stringify(this.exportParams);
      }
      window.open(`${this.exportApi}?${this.website.tokenHeader}=${getToken()}${params}`);
    },
    /* 更换文件 */
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1); // 只保留最后上传的那个
    },
    /* 上传文件 */
    addFile(file) {},
    /* 删除文件 */
    delFile() {
      this.fileList = [];
    },
    /* 保存模板数据 */
    async doSave() {
      if (this.fileList.length == 0) {
        this.$message.warning('请先上传文件！');
        return;
      }
      let isFileValid = true;
      // 下面这行代码是为了解决问题：有时候选择文件后又去本地修改了文件，这个时候上传就会报错，这个是浏览器的机制决定的
      await this.fileList[0].raw
        .slice(0, 1)
        .arrayBuffer()
        .then(() => {
          isFileValid = true;
        })
        .catch((err) => {
          isFileValid = false;
        });
      if (!isFileValid) {
        this.fileList = [];
        this.$message.warning('文件有更新，请重新上传文件后再保存');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在解析...',
        spinner: 'el-icon-loading',
      });
      let fd = new FormData();
      fd.append('file', this.fileList[0].raw);
      if (this.importParams) {
        for (let key in this.importParams) {
          fd.append(key, this.importParams[key]);
        }
      }

      request
        .post(this.importApi, fd)
        .then((res) => {
          if (res.code == 200) {
            loading.close();
            if (this.withApiTips) {
              this.$message.warning(res.msg || '导入成功！');
            } else {
              this.$message.success('导入成功！');
            }
            this.fileList = [];
            this.$emit('uploadCallBack', 'success');
          } else {
            loading.close();
            this.$message.error(res.msg);
            this.$emit('uploadCallBack', 'fail');
          }
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  .title {
    font-size: 24px;
    flex: 1;
  }

  .btn {
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
